import { useEffect } from "react";
import { EnvType, cacheService } from "../../Core/Api/services";

const useZendeskScript = () => {
  const env: EnvType = process.env.REACT_APP_ENV as EnvType;
  const logged = cacheService.IsLoggedIn();

  useEffect(() => {
    if (!logged) return;

    // Include lib
    const script = document.createElement("script");
    script.id = "ze-snippet";
    script.src = "https://static.zdassets.com/ekr/snippet.js?key=b69a01c3-f0a4-4db6-83c0-0a7260145854";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [logged]);
};

export default useZendeskScript;
